var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrossiste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 114.5 89.9",
    style: {
      enableBackground: "new 0 0 114.5 89.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60,44.9v45h47.9v-45H60z M95.1,76.5c0,1.3-1,2.3-2.3,2.3H75.1c-1.3,0-2.3-1-2.3-2.3V58.8c0-1.3,1-2.3,2.3-2.3h17.7 c1.3,0,2.3,1,2.3,2.3V76.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 34.1,
    width: 54.6,
    height: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7,10.8v79.1h47.9V10.8H6.7z M41.7,76.5c0,1.3-1,2.3-2.3,2.3H21.6c-1.3,0-2.3-1-2.3-2.3V58.8c0-1.3,1-2.3,2.3-2.3h17.7 c1.3,0,2.3,1,2.3,2.3V76.5z M41.7,41.9c0,1.3-1,2.3-2.3,2.3H21.6c-1.3,0-2.3-1-2.3-2.3V24.2c0-1.3,1-2.3,2.3-2.3h17.7 c1.3,0,2.3,1,2.3,2.3V41.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61.3,
    height: 6.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrossiste);
export default __webpack_public_path__ + "static/media/grossiste.76072e837134fc1a67dd442fefe353ac.svg";
export { ForwardRef as ReactComponent };